var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafetyScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0425 16.9064V19.3228H12.3652V11.1914C14.5343 12.1801 16.0425 14.3672 16.0425 16.9064Z",
    fill: "#6DBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00101829 16.9068C-0.00101829 14.3675 1.50691 12.1803 3.67578 11.1914V19.3228L-0.00101829 19.3229V16.9068Z",
    fill: "#6DBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2729 10.7109C5.78785 11.7167 6.8338 12.4053 8.04095 12.4053C9.24561 12.4053 10.2903 11.7195 10.8062 10.717C10.9325 10.7383 11.0579 10.7629 11.1816 10.7913V19.3247H4.85753V10.7917C4.99439 10.7601 5.13272 10.7338 5.2727 10.711L5.2729 10.7109Z",
    fill: "#6DBFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10587 3.85045H3.42603C3.6387 2.64578 4.311 1.59983 5.25508 0.900411V3.85045H6.07427V0.414025C6.5549 0.191505 7.08052 0.0474245 7.6329 0V3.85009H8.45159L8.45142 0.000125959C9.00376 0.0477143 9.52842 0.191467 10.0096 0.414151V3.85024H10.8282V0.900201C11.7729 1.59958 12.4456 2.64557 12.6573 3.85024H12.9779C13.2041 3.85024 13.3877 4.03354 13.3877 4.2595C13.3877 4.48579 13.2039 4.66909 12.9779 4.66909H3.10528C2.87866 4.66909 2.69602 4.48579 2.69602 4.2595C2.69651 4.0337 2.87964 3.8504 3.10594 3.8504L3.10587 3.85045Z",
    fill: "#6DBFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4245 5.36752C12.4245 7.78798 10.4616 9.75037 8.04126 9.75037C5.6208 9.75037 3.65883 7.78807 3.65883 5.36752C3.65883 5.34701 3.65982 5.32699 3.65982 5.30664H12.423C12.423 5.32715 12.4248 5.34701 12.4248 5.36752H12.4245Z",
    fill: "#6DBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyScore);
export default __webpack_public_path__ + "static/media/safetyScore.468ef885f6333026b0c2820480e5aa1d.svg";
export { ForwardRef as ReactComponent };